import Fifth from './Fifth'
import First from './First'
import Fourth from './Fourth'
import Second from './Second'
import Sixth from './Sixth'
import Third from './Third'

export default [First, Second, Third, Fourth, Fifth, Sixth]
